module.exports = __webpack_public_path__ + "img/logo.94bbdc81.svg";